import { NgModule } from '@angular/core';
import { FooterComponent } from '@app/pcs/footer/footer.component';

@NgModule({
  declarations: [
    FooterComponent
  ],
  exports: [
    FooterComponent
  ]
})
export class FooterModule {
}
